import React, { useState, useRef, useEffect } from "react";
import { withSidebar } from "../hoc/withSidebar";
import { useDispatch, useSelector } from "react-redux";
import NewHscbcBiller from "./NewBillerHsbcUser";
import NewBillerProfileUser from "./NewBillerProfileUser";
import { ResponsiveBox } from "../primitives";

function NewBillerUser(props) {
  const fiNumber = useSelector(
    (state) => state?.loginUserReducer?.user?.fiNumber
  );
  const selectedFiNumber = useSelector((state) => state?.fiReducer.selectedFi);

  return fiNumber != 16 ? (
    <NewBillerProfileUser {...props} />
  ) : (
    <NewHscbcBiller {...props} />
  );
}
export default withSidebar(NewBillerUser);
